// export const BASE_URL = 'http://localhost:9033';
export const BASE_URL = 'https://teraquiz.com';

export const PAYMENT_URL = '/microservice.pagarme/create.order';
export const VALIDATE_PAYMENT = '/microservice.pagarme/get.order.by.id';
export const CREATE_ORDER = '/microservice.pagarme/create.order';
export const GET_CHECKOUT_BY_ID = '/microservice.pagarme/get.checkout.by.id';

